export default __webpack_public_path__ + "static/media/alignment-left.a33dfe76.svg";